<template lang="pug">
app-page(:fab-items="fabItems" title="Шаблоны запросов")
    app-toolbar(v-if="isOrgLoaded" :title="'Шаблоны организации \"'+currentOrg.name+'\"'")
            
    v-layout(align-start)
      v-flex(xs9 sud-block-overlay)
        .sud-block-title Файлы
        v-layout(row wrap v-if="isOrgTemplatesLoaded && orgTemplates.length > 0")
          v-flex.px-4(xs4 v-for="(a, index) in orgTemplates" :key="index"  )
            app-card(@click.native="selectItem(a)")
              app-card-header.file__header
                | {{ a.walias }}
              app-card-body.file__body
                app-card-title.file__title(v-line-clamp="2") {{ a.name }}

      v-flex(xs3 sud-block-overlay)
        .sud-block-title Информация об организации
        app-card(v-if="isOrgLoaded" @click.native="editOrg")
          app-card-header
            span(v-if="currentOrg.organizationCategory != null") {{ currentOrg.organizationCategory.title }}
          app-card-body
            app-card-title(v-line-clamp="2") {{ currentOrg.name }}

            app-card-caption.mt-2  Адрес: 
              strong {{ currentOrg.address }} 
            app-card-caption.mt-1(v-if="currentOrg.city!=''") Город: 
              strong {{ currentOrg.city }}
            app-card-caption.mt-1(v-if="currentOrg.phone!=''") Телефон: 
              strong {{ currentOrg.phone }}
            app-card-caption.mt-1(v-if="currentOrg.fax!=''") Факс:
              strong {{ currentOrg.fax }}
            app-card-caption.mt-1(v-if="currentOrg.email!=''") E-mail: 
              strong {{ currentOrg.email }}
            app-card-caption.mt-1(v-if="currentOrg.site!=''") Сайт: 
              strong {{ currentOrg.site }}
            app-card-caption.mt-1(v-if="currentOrg.sendChannel") Тип доставки: 
              strong {{ currentOrg.sendChannel.title }}
            app-card-caption.mt-1 Сертификат: 
               strong(v-if="currentOrg.hasCert") установлен
               strong(v-else) нет


    addOrg(v-model="dialogAddOrg" :org.sync="currentOrg")

    addTemplate(v-model="dialogAddTemplate" :template.sync="template" :org="currentOrg")

    app-dialog(v-model="dialogFile" header="Выбранный файл" :items="fileItems")

    app-dialog-confirm(v-if="template" v-model="deleteConfirm" confirm-button="Удалить" @confirm="deleteDoc") 
      | Удалить шаблон {{ template.name }}?

    v-snackbar(v-model="forbiddenError" color="red lighten-2" :timeout="6000" vertical bottom) Действия с шаблоном запрещены
      v-btn(light text @click="forbiddenError = false") Закрыть



</template>

<script>
import { AppToolbarItemDivider, AppDialogConfirm, AppDialogLoading } from '@/components'
import { mapGetters, mapMutations } from 'vuex';
import addOrg from './components/AddOrg'
import addTemplate from './components/AddTemplate'
import { organizationService } from '@/_services'

export default {
  components: {
    [AppDialogConfirm.name]: AppDialogConfirm,
    [AppDialogLoading.name]: AppDialogLoading,
    addOrg,
    addTemplate
  },
  props: {
    orgId: null
  },

  methods: {
    ...mapMutations('organization', [ 'selectCategory']),

    selectItem (item) {
      this.dialogFile = true
      this.template = item
    },

    editOrg() {
      this.dialogAddOrg = true
    },

    addItem () {
      this.template = null
      this.dialogAddTemplate = true
    },

    deleteDoc () {
      this.$store.dispatch('organization/DELETE_TEMPLATE', { templateId: this.template.id })
      .then(() => this.forbiddenError=false)
      .catch(() => this.forbiddenError=true)
    },

    openDoc () {
      organizationService.getTemplateURL(this.template.id).then(data => { 
        let link="ms-word:ofe|u|"+document.location.origin+data
        window.open(link, '_blank') 
      })
    },

  },

  data() {
    return {
      forbiddenError: false,
      deleteConfirm: false,
      dialogFile: false,
      dialogAddTemplate: false,
      dialogAddOrg: false,
      template: null
    }
  },


  computed: {
    ...mapGetters('organization', ['currentOrg','isOrgLoaded', 'orgTemplates', 'isOrgTemplatesLoaded']),

    fabItems () {
      return [
        AppToolbarItemDivider, 
        { icon:'add', title:'Добавить шаблон', action: () => this.dialogAddTemplate = true }
      ]
    },

    fileItems () {
      let items = [{ icon: 'edit', title: 'Редактировать', action: () => this.openDoc() }]
      items.push({ icon: 'delete', title: 'Удалить', action: () => this.deleteConfirm = true })
      return items
    },

  },
  created() {
    this.$store.dispatch('organization/INIT_ITEM', { orgId: this.orgId })
  }
}


</script>

<style scoped>
</style>
